"use client";

import { useMutation } from "@tanstack/react-query";

import { Post } from "@/shared/libs/axios/request";
import type {
  ItemCategory,
  SearchItemsByImageRequest,
  SearchItemsByImageResponse,
} from "@stocks/shared";

export interface SearchItemsByImageInput
  extends Pick<SearchItemsByImageRequest, "spec"> {
  files: File[];
  category?: ItemCategory | "";
}

/** 업로드한 사진과 닮은 기존 품목 추천 (이미지 비교 검색). */
export const useSearchItemsByImage = () =>
  useMutation({
    mutationFn: async ({ files, category, spec }: SearchItemsByImageInput) => {
      const form = new FormData();
      files.forEach((f) => form.append("files", f));
      if (category) form.append("category", category);
      if (spec?.trim()) form.append("spec", spec.trim());
      const res = await Post<SearchItemsByImageResponse, FormData>(
        "/v1/items/search-by-image",
        form,
        { headers: { "Content-Type": "multipart/form-data" } },
      );
      return res.data.data;
    },
  });
